import { render, staticRenderFns } from "./topBanner.vue?vue&type=template&id=37d6a17a&scoped=true"
import script from "./topBanner.vue?vue&type=script&lang=js"
export * from "./topBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d6a17a",
  null
  
)

export default component.exports